import { useMutation } from '@tanstack/react-query';
import { type ArticleEditValues } from '@shared/types/articles';
import { API } from '@src/api/index.ts';
import { queryClient } from '@src/api/query-client.ts';

export const useCreateArticleMutation = () => {
  return useMutation({
    mutationFn: async (params: ArticleEditValues) => await API.articles.create(params),
    onSuccess: () => {
      // очищаем кеш, чтобы запросить статьи заново (после создания новой)
      queryClient.setQueriesData({ queryKey: ['articles'] }, undefined);
    },
  });
};
